export const TOURS_RECORD_KEY = 'tours';

export interface TOUR {
    name: string;
    template: string;
}
